const sections = ['', 'business', 'executors', 'cases', 'smi'] as const;

export default sections;
